export const kanboardConstants = {
  //get job details
  GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_REQUEST",
  GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_FAILURE",

  // get filtered job details
  GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_REQUEST",
  GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_FAILURE",

  // get filtered job details
  UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_REQUEST:
    "UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_REQUEST",
  UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_SUCCESS:
    "UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_SUCCESS",
  UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_FAILURE:
    "UPDATE_APPLICANT_PROFILE_STATUS_KANBOARD_HIRING_MANAGER_ACTION_FAILURE",
};
